import React, { useState } from 'react';

import { const_var } from '../../../redux/reducers/reducer'

import CupolaModel from './CupolaModel';

const Cupolas = () => {
    const [overlapArr, setOverlapArr] = useState([])
    
    return (
        <>
            {const_var.cupolas.map(item => 
                <CupolaModel key={`cupola-model-${item.uniqueId}`} name={`cupola${item.uniqueId}`} item={item} overlapArr={overlapArr} setOverlapArr={setOverlapArr} />
            )}
        </>
    );
}

export default Cupolas;